


















import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { RadioOptions, RadioDef } from '../../type'
import OptionFieldMixins from './OptionFieldMixins'

@Component
export default class RadioControl extends mixins(OptionFieldMixins) {
  get options () {
    return Object.assign(new RadioOptions(), this.def?.options)
  }

  def!: RadioDef
}
